import * as React from 'react';
import { useParams } from 'react-router-dom';
import styles from './InboxPage.module.css';
import { RightPane } from './RightPane';
import { LeftPane } from './LeftPane';
import { Button, Offcanvas } from 'react-bootstrap';

export const InboxPage = (): React.JSX.Element => {
  const params = useParams();
  const activeConvoId = !!params.convoId ? Number(params.convoId) : null;
  const [showConvos, setShowConvos] = React.useState(!params.convoId);

  return (
    <div className={styles.InboxPage}>
      <Offcanvas show={showConvos} onHide={() => setShowConvos(false)} responsive="sm">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Conversations</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className={styles.LeftPane}>
            <LeftPane activeConvoId={activeConvoId} closePane={() => setShowConvos(false)} />
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <div className={styles.RightPane}>
        <div className={styles.OffcanvasButton}>
          <Button variant="link" size="sm" onClick={() => setShowConvos(true)}>
            Back to Conversations
          </Button>
          <br />
          <br />
        </div>
        {params.convoId && <RightPane convoId={activeConvoId} />}
        {!params.convoId && <div>Select a conversation to see it here</div>}
      </div>
    </div>
  );
};
